// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"abbd2113","787":"92ea23a9"}[chunkId] + ".chunk.js";
};